import { render, staticRenderFns } from "./agencyDetails.vue?vue&type=template&id=50c45128&scoped=true&"
import script from "./agencyDetails.vue?vue&type=script&lang=ts&"
export * from "./agencyDetails.vue?vue&type=script&lang=ts&"
import style0 from "./agencyDetails.vue?vue&type=style&index=0&id=50c45128&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c45128",
  null
  
)

export default component.exports